import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { ELEMENT_NUMBERING } from './defaults';
import { NumberingPluginOptions } from './types';

const NumberingElement = dynamicEditorComponent<RenderElementProps>(() =>
  import('./component/NumberingElement').then((mod) => mod.NumberingElement)
);

export const renderNumberingElement =
  (options: NumberingPluginOptions) =>
  ({ element, children, attributes }: RenderElementProps) => {
    if (element.type === ELEMENT_NUMBERING) {
      return (
        <NumberingElement element={element} attributes={attributes} {...options}>
          {children}
        </NumberingElement>
      );
    }
    return null;
  };
